import { EpDevPPluginIds } from '../../constants';
import { TApiBasePathParam } from './api';

export type TEpDevPHealthApiGetPathParams = TApiBasePathParam & {
}
export type TEpDevPHealthApiHealthQueryParams = {
  includeDetails: boolean;
}
export type TEpDevPHealthApiPluginHealthPathParams = TApiBasePathParam & {
  pluginId: EpDevPPluginIds;
}
export type TEpDevPHealthApiPluginHealthQueryParams = {
  includeDetails: boolean;
}


export enum EEpDevPHealthStatus {
  OK = "ok",
  NOT_OK = "not-ok"
}
export interface IEpDevPHealthResponse {
  status: EEpDevPHealthStatus;
  details: any;
}
export interface IEpDevPPluginHealthCreate {
  status: EEpDevPHealthStatus;
  details: any;
}
export interface IEpDevPPluginHealthResponse extends IEpDevPHealthResponse {
  details: any;
}

export interface IEpDevPHealthApiClient {

  getHealth({ includeDetails }:{
    includeDetails: boolean;
  }): Promise<IEpDevPHealthResponse>;

  getPluginHealth({ pluginId, includeDetails }:{
    pluginId: EpDevPPluginIds;
    includeDetails: boolean;
  }): Promise<IEpDevPPluginHealthResponse>;

  setPluginHealth({ pluginId, epDevPPluginHealthCreate }:{
    pluginId: EpDevPPluginIds;
    epDevPPluginHealthCreate: IEpDevPPluginHealthCreate;
  }): Promise<void>;

}
